import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6h10l-10 12h10","key":"svg-0"}],["path",{"d":"M12 4v2","key":"svg-1"}],["path",{"d":"M12 18v2","key":"svg-2"}]]

/**
 * IconCurrencyZcash
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktemNhc2giCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgNmgxMGwtMTAgMTJoMTAiIC8+CiAgPHBhdGggZD0iTTEyIDR2MiIgLz4KICA8cGF0aCBkPSJNMTIgMTh2MiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-zcash
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyZcash = createReactComponent('outline', 'currency-zcash', 'CurrencyZcash', __iconNode);

export default IconCurrencyZcash;